import { HelmetProvider } from 'react-helmet-async'
import { Toaster } from 'react-hot-toast'
import { IntlProvider } from 'react-intl'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'

import ScreenSizeContainer from 'shared/ui/ScreenSizeContainer'
import useDisablePinchZoom from 'shared/hooks/useDisablePinchZoom'
import { useIntercom } from 'shared/hooks/useIntercom'
import ServiceAccessGate from 'shared/components/ServiceAccessGate'
import 'shared/styles/fonts.css'
import { theme } from 'shared/styles/theme'
import { Locales } from 'shared/types/global'

import Router from './shared/components/Router'
import GlobalStyle from './shared/styles/global'
import { TOASTER_Z_INDEX } from './shared/styles/z-index'

type AppProps = {
  locale: Locales
  messages: Record<string, string>
}

const App: React.FC<AppProps> = ({ locale, messages }) => {
  useIntercom()
  useDisablePinchZoom()

  return (
    <>
      <GlobalStyle />
      <Toaster containerStyle={{ zIndex: TOASTER_Z_INDEX }} />
      <ThemeProvider theme={theme}>
        <IntlProvider locale={locale} messages={messages}>
          <HelmetProvider>
            <BrowserRouter>
              <ServiceAccessGate>
                <ScreenSizeContainer>
                  <Router />
                </ScreenSizeContainer>
              </ServiceAccessGate>
            </BrowserRouter>
          </HelmetProvider>
        </IntlProvider>
      </ThemeProvider>
    </>
  )
}

export default App
